import { render, staticRenderFns } from "./CircleBubble.vue?vue&type=template&id=67d52928&scoped=true&"
import script from "./CircleBubble.vue?vue&type=script&lang=js&"
export * from "./CircleBubble.vue?vue&type=script&lang=js&"
import style0 from "./CircleBubble.vue?vue&type=style&index=0&id=67d52928&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d52928",
  null
  
)

export default component.exports